/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './core-lazy.module';
export { LAZY_SYMBOLS } from './lazy-activator.service';
export * from './lazy-registry.service';
